import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent, ref, reactive } from 'vue';
import { get_setting, get_search_list, get_tags } from "@/service/api";
import { useRouter } from 'vue-router';
import { mapActions, mapState, mapMutations, useStore } from "vuex";
import router from "@/router";
import { appPath } from "@/config/settings";

// Remove slash symbols from string
function getToolsetName(path) {
  let cleaned = path.replace(appPath, '');
  if (cleaned.startsWith('/')) {
    cleaned = cleaned.replace(/^\/+/, '');
  }
  let result = '';
  if (cleaned.includes('/')) {
    result = cleaned.split('/')[0];
  } else {
    result = cleaned;
  }
  return result;
}
export default defineComponent({
  name: "Layout",
  components: {},
  data() {
    return {
      title: "",
      drawer: false,
      optionLinks: null,
      otherLinks: null,
      tags: [],
      logoHref: "#"
    };
  },
  created() {
    this.setLogoHref();

    // 从 URL hash 恢复 tag 过滤状态
    const hash = this.$route.hash;
    if (hash && hash.startsWith('#tag=')) {
      const tagFromUrl = decodeURIComponent(hash.substring(5)).replace(/_/g, ' ');
      if (tagFromUrl !== this.$store.state.current_tag) {
        this.set_current_tag(tagFromUrl);
      }
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    },
    ...mapState({
      rows_count: state => state.component_rows
    }),
    rows: {
      get() {
        return this.$store.state.component_rows;
      },
      set(value) {
        if (this.$store.state.component_rows !== value) {
          this.set_local_rows(value);
        }
      }
    },
    current_tag: {
      get() {
        return this.$store.state.current_tag;
      },
      set(value) {
        if (this.$store.state.current_tag !== value) {
          this.set_current_tag(value);
          const hash = value === 'All' ? '' : `tag=${encodeURIComponent(value).replace(/%20/g, '_')}`;
          const url = window.location.pathname + window.location.search + (hash ? '#' + hash : '');
          history.replaceState(history.state, '', url);
        }
      }
    },
    current_version: {
      get() {
        return this.$store.state.current_rhino_version;
      },
      set(value) {
        if (this.$store.state.current_rhino_version !== value) {
          // 走 action 而非 mutation，以便同时写入 localStorage
          this.set_local_rhino_version(value);
        }
      }
    },
    app_path() {
      return router.currentRoute.value.path.split('/').slice(0, 2).join('/');
    },
    isMobile() {
      return window.innerWidth <= 768;
    }
  },
  setup() {
    const router = useRouter();
    const store = useStore();
    const marks = reactive({
      2: {
        style: {
          fontSize: '1rem',
          color: '#ffffff'
        },
        label: '2'
      },
      3: {
        style: {
          fontSize: '1rem',
          color: '#ffffff'
        },
        label: '3'
      },
      4: {
        style: {
          fontSize: '1rem',
          color: '#ffffff'
        },
        label: '4'
      },
      5: {
        style: {
          fontSize: '1rem',
          color: '#ffffff'
        },
        label: '5'
      },
      6: {
        style: {
          fontSize: '1rem',
          color: '#ffffff'
        },
        label: '6'
      }
    });
    const operator = ref([]);
    const querySearch = (queryString, cb) => {
      let firstList = queryString ? operator.value.filter(createFilter(queryString)) : operator.value;
      let inlineList = queryString ? operator.value.filter(createFilter(queryString, 1)) : operator.value;
      let results = firstList.concat(inlineList);
      // Call callback to return suggestions

      cb(results);
    };
    const createFilter = (queryString, para = 0) => {
      if (para === 0) {
        return Operator => {
          return Operator.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
        };
      }
      return Operator => {
        return Operator.value.toLowerCase().indexOf(queryString.toLowerCase()) > 0;
      };
    };
    const handleSelect = item => {
      // Use appPath and getToolsetName for a more robust base path
      const currentPath = router.currentRoute.value.path;
      const toolsetName = getToolsetName(currentPath); // getToolsetName is defined in the script scope

      console.log("Original appPath:", appPath);
      console.log("Original toolsetName:", toolsetName);

      // Robust basePath construction
      const appPathCleaned = appPath.replace(/^\/+/, '').replace(/\/+$/, '');
      const toolsetNameCleaned = toolsetName.replace(/^\/+/, '').replace(/\/+$/, '');
      let basePath = '';
      if (appPathCleaned && toolsetNameCleaned) {
        basePath = `/${appPathCleaned}/${toolsetNameCleaned}`;
      } else if (appPathCleaned) {
        basePath = `/${appPathCleaned}`;
      } else if (toolsetNameCleaned) {
        basePath = `/${toolsetNameCleaned}`;
      } else {
        basePath = '/'; // Fallback to root if both are empty, though unlikely
      }
      // Ensure basePath starts with a single slash and does not end with one if it's not just '/'
      basePath = basePath.replace(/\/+/g, '/'); // Replace multiple slashes with single
      if (basePath !== '/' && basePath.endsWith('/')) {
        basePath = basePath.slice(0, -1);
      }
      if (!basePath.startsWith('/')) {
        basePath = '/' + basePath;
      }
      const targetPath = `${basePath}/${item.category}/${item.name_in_url}`;
      console.log("Navigating to:", targetPath);
      console.log("Item details:", JSON.parse(JSON.stringify(item))); // Log a clean copy of the item

      router.push({
        path: targetPath
      });
      store.dispatch('updateHighlightedIconId', item.id);
      // 额外标记「这次是从搜索点进来的」。图标区据此先滚回去做一次聚焦动效，
      // 再滚到组件详情——搜索结果可能来自任意分类，目标图标往往不在视线里。
      store.dispatch('markSearchNavigation', item.id);
    };
    return {
      Operator: operator,
      state: ref(''),
      querySearch,
      createFilter,
      handleSelect,
      marks
    };
  },
  beforeMount() {
    this.getTitle();
    this.get_local_rows();
    // 恢复用户上次选择的 Rhino 版本，需在子组件渲染前完成
    this.get_local_rhino_version();
    this.getTags();
  },
  mounted() {
    get_search_list(getToolsetName(router.currentRoute.value.path)).then(result => {
      this.Operator = result.data;
    });
    get_setting('option_links').then(result => {
      this.optionLinks = result.data;
    });
    get_setting('other_links').then(result => {
      this.otherLinks = result.data;
    });
  },
  methods: {
    ...mapActions({
      get_local_rows: "get_local_rows",
      set_local_rows: "set_local_rows",
      get_local_rhino_version: "get_local_rhino_version",
      set_local_rhino_version: "set_local_rhino_version"
    }),
    ...mapMutations({
      set_current_tag: "set_current_tag",
      set_current_rhino_version: "set_current_rhino_version"
    }),
    setLogoHref() {
      // Get the current page URL path
      const currentUrl = window.location.pathname;

      // Configure paths and corresponding basePaths
      const basePathMap = {
        "/docs/ghplugins": "/docs/ghplugins",
        "/docs/grasshopper2": "/docs/grasshopper2",
        "/docs/grasshopper": "/docs/grasshopper"
      };

      // Initialize default basePath
      let basePath = "";

      // Iterate through basePathMap to find matching basePath
      for (const path in basePathMap) {
        if (currentUrl.startsWith(path)) {
          basePath = basePathMap[path];
          break;
        }
      }

      // Set logoHref to the found basePath
      this.logoHref = basePath ? basePath : "/docs/grasshopper";
    },
    getTitle() {
      get_setting("GhTitle").then(result => {
        this.title = result.data.text;
      });
    },
    getTags() {
      get_tags().then(result => {
        this.tags = result.data;
      });
    },
    openCopyrightLink() {
      window.open('https://www.rhino3d.com/mcneel/about/', '_blank', 'noopener,noreferrer');
    }
  }
});